L.Control.TileLayerSwitch = L.Control.extend({
    options: {
        position: 'topright'
    },

    initialize: function (options) {
        L.setOptions(this, options);
    },

    onAdd: function (map) {
        this._map = map;
        this._initLayout();

        return this._container;
    },

    _initLayout: function () {
        // note: using bootstrap classes!
        var className = 'leaflet-control-layerswitch',
            container = this._container = L.DomUtil.create('div', className),
            buttonGroup = L.DomUtil.create('div', 'btn-group', container),
            tileLayersLen = this.options.tileLayers.length;

        for (var i = 0; i < tileLayersLen; i++) {
            var tileLayer = this.options.tileLayers[i];
            
            this._addButton(buttonGroup, tileLayer.active, tileLayer.name);
        }
    },

    _addButton: function (container, isActive, text) {
        var className = 'btn ' + (isActive ? 'btn-primary' : 'btn-default');
        var button = L.DomUtil.create('button', className, container);
        button.innerText = text;
        L.DomEvent.on(button, 'click', this._buttonClick, this);
    },

    _buttonClick: function (e) {
        var buttons = this._container.getElementsByTagName('button'),
            buttonsLen = buttons.length,
            layerName = e.currentTarget.innerText;

        for (var i = 0; i < buttonsLen; i++) {
            var button = buttons[i];

            button.className = (button === e.currentTarget)
                ? 'btn btn-primary'
                : 'btn btn-default';
        }

        this._activateLayer(layerName);
    },
    
    _activateLayer: function(name) {
        var tileLayersLen = this.options.tileLayers.length;

        for (var i = 0; i < tileLayersLen; i++) {
            var obj = this.options.tileLayers[i];
            
            if (obj.name === name) {
                this._map.addLayer(obj.layer);
                this._map.fire("map:tiles:updated", { name: name });
            } else {
                this._map.removeLayer(obj.layer);
            }
        }
    }
});

L.control.tileLayerSwitch = function (tileLayers, options) {
    return new L.Control.TileLayerSwitch(tileLayers, options);
};

define("leaflet-tilelayer-switch", function(){});

